export default __webpack_public_path__ + "static/media/osmosis-test.f111e77d.jpg";